import React, { ReactElement } from 'react';
import { ZoomIcon } from '../../../components/common/Icon/BrigthnessIcon';
import ZoomIconTable from '../../../assets/Table/zoomIcon.svg';
import { EcrouIcon } from '../../../components/common/Icon/EcrouIcon';
import { LocalStorage } from '../../localStorage';
import { render } from '@testing-library/react';
import CloseIcon from 'saur_ui_library/src/Icons/Close';
import { resetImputLabel } from '../module/filtersHelper';
import {
  cellDetailIconComponent,
  cellZoomIconComponent,
} from '../../../components/module/table/columnIconComponent';
import DetailIcon from '../../../assets/Table/showDetails.svg';
import { ColumnConfig, createColumn } from './createColumnHelper';
import ResetStyleComponent from '../../../components/cssSaur/resetStyleComponent';
import { getEcpMode } from '../view/ecpDetailHelper';

// reset to empty the label of input dropdownlist
export const resetInputedValue = (pResponse: any[], pModule: string) => {
  if (pResponse.length === 0) {
    resetImputLabel(pModule + '-filtre-installations');
    resetImputLabel(pModule + '-filtre-communes');
  }
};

export const columnComponent = (
  pTitle: string,
  pParams: any,
  pCellFunction: Function,
) => {
  let render = {
    id: pParams.id,
    header: pTitle,
    accessorKey: pParams.accessorKey,
    Cell: pCellFunction,
    size: pParams.size,
    enableSorting: pParams.enableSorting,
    muiTableHeadCellProps: {
      align: 'center',
    },
    Header:
      pTitle === 'none' ? (
        <i style={{ color: pTitle === 'none' ? 'white' : 'black' }}>{pTitle}</i>
      ) : null,
  };
  return render;
};

export const cellReturnData = (pIdDiv: string, pOutfield: string) => {
  return (row: any) => {
    return (
      <div id={row.row.index + pIdDiv} style={{ fontSize: '14px' }}>
        {row.row.original[pOutfield] !== undefined
          ? row.row.original[pOutfield]
          : 'NR'}
      </div>
    );
  };
};

export const cellReturnCateg = (pAccessorKey: string) => {
  return (row: any) => {
    return colorHeader(row.cell.id, row.row.original[pAccessorKey]);
  };
};

export const cellReturnZoomIcon = (zoomToPointTrigger?: (point: {x: number, y: number}) => void) => {
  return (row: any) => {
    return cellZoomIconComponent({
      icon: ZoomIconTable,
      row: row,
      id: row.cell.id,
      zoomToPointTrigger: zoomToPointTrigger,
    });
  };
};

export const cellReturnDetailIcon = (pHistory: any, pModule: string) => {
  return (row: any) => {
    return cellDetailIconComponent({
      icon: DetailIcon,
      row: row,
      history: pHistory,
      module: pModule,
      id: row.cell.id,
    });
  };
};

export const pointColor = (props: any) => {
  return (
    <div>
      <ZoomIcon
        className={props.className + '-icon'}
        id={props.id}
        color={props.color}
      />
    </div>
  );
};

// color on row in all table list
export const colorHeader = (
  id: string,
  acessorName: string | number,
): ReactElement => {
  switch (acessorName) {
    case 'ROUGE':
    case 3:
      return pointColor({
        className: 'red',
        id: id,
        color: '#FE3123',
      });
    case 'ORANGE':
    case 2:
      return pointColor({
        className: 'orange',
        id: id,
        color: '#FFBF66',
      });
    case 'BLEU':
      return pointColor({
        className: 'blue',
        id: id,
        color: '#008BD2',
      });
    case 'VERT':
    case 1:
      return pointColor({
        className: 'vert',
        id: id,
        color: '#76D19B',
      });
    case 'GRIS':
      return pointColor({
        className: 'gris',
        id: id,
        color: '#E9E9E9',
      });
    case 'VIOLET':
      return pointColor({
        className: 'violet',
        id: id,
        color: '#A500B5',
      });
    default:
      return pointColor({
        className: 'black',
        id: id,
        color: '#000000',
      });
  }
};

export const saveDataInStorage = (row) => {
  LocalStorage.prCode.set(row.row.original.Code);
  window.sessionStorage.setItem('Code', row.row.original.Code);
  // prevContractCode used for changing contract on PrDetail and DoDetail pages and backword on PrTable page
  const currentContractCode = window.sessionStorage.getItem('contractCode')!;
  if (currentContractCode !== null) {
    window.sessionStorage.setItem('prevContractCode', currentContractCode);
  }
  LocalStorage.prName.set(row.row.original.Description);
};

export const getHour = (date: any) => {
  const FormatDate = new Date(date);
  return FormatDate.getHours() + 'h';
};

export const getH2sDataColor = (): string => {
  // Get H2S indicator name with cache invalidation for Tps séjour PR
  const indicatorModule: string | null =
  window.sessionStorage.getItem('h2s_indicator');
  let color: string = '';
  
  // Ensure we have a valid indicator
  if (!indicatorModule) {
    console.warn('No H2S indicator found in session storage, defaulting to ColorTerrain');
    return 'ColorTerrain';
  }
  
  switch (indicatorModule) {
    case 'IndicatorBoonLister':
      color = 'ColorBoonLister';
      break;
    case 'IndicatorSejourCana':
      color = 'ColorSejourCana';
      break;
    case 'IndicatorSejourPR':
      color = 'ColorSejourPR';
      break;
    case 'IndicatorAutocurage':
      color = 'ColorAutocurage';
      break;
    default:
      color = 'ColorTerrain';
      break;
  }

  return color;
}
//Switch H2S color column indicator values function
export const h2sColumns = () => {

  // H2S
  return [
    {
      header: '',
      accessorKey: 'Color',
      id: 'h2s-color',
      size: 20,
      cellReturn: {
        name: 'categ',
        key: '_h2s-color',
        value: getH2sDataColor(),
      },
    },
    {
      header: 'Commune',
      accessorKey: 'Commune',
      cellReturn: { name: 'data', key: '_h2s-commune', value: 'Commune' },
    },
    {
      header: 'Nom',
      accessorKey: 'Description',
      cellReturn: { name: 'data', key: '_h2s-nom', value: 'Description' },
    },
    {
      header: 'Type',
      accessorKey: 'ModelCode',
      size: 80,
      cellReturn: { name: 'data', key: '_h2s-type', value: 'ModelCode' },
    },
  ].map(createColumn);
};

export const h2sMicroColumns = [
  {
    accessorKey: 'h',
    header: '',
    size: 50,
    Cell: (row: any) => {
      return (
        <div id={'heure-' + row.row.index}>
          {getHour(row.row.original.date)}
        </div>
      );
    },
  },
  {
    accessorKey: 'tsH2S',
    header: 'Temps de séjour (h)',
    muiTableHeadCellProps: { align: 'center', sx: { color: '#1156B2' } },
    Cell: (row: any) => {
      return (
        <div id={'h2s-ts-' + row.row.index}>
          {row.row.original.tsH2S ? row.row.original.tsH2S : 'NR'}
        </div>
      );
    },
  },
  {
    accessorKey: 'vdavg',
    header: 'Volume journalier refoulé (m³)',
    size: 280,
    muiTableHeadCellProps: {
      align: 'center',
      sx: { color: '#FFBF66', fontSize: '15px' },
    },
    Cell: (row: any) => (
      <div id={'h2s-vj-' + row.row.index}>
        {row.row.original.vdavg ? row.row.original.vdavg : 'NR'}
      </div>
    ),
  },
  {
    accessorKey: 'boonlister',
    header: 'Boon et Lister',
    muiTableHeadCellProps: {
      align: 'center',
    },
    Cell: (row: any) => (
      <div id={'h2s-bl-' + row.row.index}>
        {row.row.original.boonlister ? row.row.original.boonlister : 'NR'}
      </div>
    ),
  },
];

// ECP
// ECP columns function - reads mode from sessionStorage like H2S does
export const ecpColumns = () => {
  const ecpMode = getEcpMode();

  // STEP mode: simplified columns (Commune + Installation only)
  if (ecpMode === 'step') {
    return [
      {
        header: 'Commune',
        accessorKey: 'Commune',
        cellReturn: { name: 'data', key: '_ecp-commune', value: 'Commune' },
      },
      {
        header: 'Installation',
        accessorKey: 'Description',
        cellReturn: { name: 'data', key: '_ecp-installation', value: 'Description' },
      },
    ].map(createColumn);
  }

  // PR mode: full columns (default)
  return [
    {
      header: '',
      accessorKey: 'Color',
      id: 'ecp-color',
      size: 30,
      cellReturn: { name: 'categ', key: '_ecp-color', value: 'Color' },
    },
    {
      header: 'Commune',
      accessorKey: 'Commune',
      cellReturn: { name: 'data', key: '_ecp-commune', value: 'Commune' },
    },
    {
      header: 'Bassin de collecte',
      accessorKey: 'collectionPoolLabel',
      cellReturn: {
        name: 'data',
        key: '_ecp-collectionPool',
        value: 'collectionPoolLabel',
      },
    },
    {
      header: 'Point Aval',
      accessorKey: 'Description',
      cellReturn: { name: 'data', key: '_ecp-aval', value: 'Description' },
    },
  ].map(createColumn);
};

export const getDate = (baddate: any) => {
  let valueDate;
  if (baddate) {
    valueDate = new Date(baddate).toLocaleDateString('fr');
  } else {
    valueDate = 'NR';
  }
  return valueDate;
};

export const showValue = (zero: any) => {
  if (zero === 0) {
    return '0';
  } else if (zero) {
    return zero;
  } else {
    return 'NR';
  }
};

// dataStatColumns
export const dataStatColumns: ColumnConfig[] = [
  {
    header: 'Record Date',
    accessorKey: 'recordDate',
    cellReturn: {
      name: 'row',
      key: '',
      value: (row: any) => {
        // eslint-disable-next-line no-lone-blocks
        {
          return (
            <div id={'data-recorddate-' + row.row.index}>
              {row.row.original.recordDate}
            </div>
          );
        }
      },
    },
  },
  {
    header: 'Integration Date',
    accessorKey: 'integrationDate',
    cellReturn: {
      name: 'row',
      key: '',
      value: (row: any) => {
        // eslint-disable-next-line no-lone-blocks
        {
          return (
            <div id={'data-integrationDate-' + row.row.index}>
              {getDate(row.row.original.integrationDate)}
            </div>
          );
        }
      },
    },
  },
  {
    header: 'Object',
    accessorKey: 'object',
    cellReturn: {
      name: 'row',
      key: '',
      value: (row: any) => {
        return (
          <div id={'data-object-' + row.row.index}>
            {row.row.original.object}
          </div>
        );
      },
    },
  },
  {
    header: 'StatsIndicator',
    accessorKey: 'statsIndicator',
    cellReturn: {
      name: 'row',
      key: '',
      value: (row: any) => (
        <div id={'data-statsIndicator-' + row.row.index}>
          {row.row.original.statsIndicator}
        </div>
      ),
    },
  },
  {
    header: 'Region',
    accessorKey: 'region',
    cellReturn: {
      name: 'row',
      key: '',
      value: (row: any) => (
        <div id={'data-region-' + row.row.index}>{row.row.original.region}</div>
      ),
    },
  },
  {
    header: 'ModelCode',
    accessorKey: 'modelCode',
    cellReturn: {
      name: 'row',
      key: '',
      value: (row: any) => (
        <div id={'data-modelCode-' + row.row.index}>
          {row.row.original.modelCode}
        </div>
      ),
    },
  },
  {
    header: 'ClassMeasureCode',
    accessorKey: 'classMeasureCode',
    cellReturn: {
      name: 'row',
      key: '',
      value: (row: any) => (
        <div id={'data-classMeasureCode-' + row.row.index}>
          {row.row.original.classMeasureCode}
        </div>
      ),
    },
  },
  {
    header: 'Value',
    accessorKey: 'value',
    cellReturn: {
      name: 'row',
      key: '',
      value: (row: any) => (
        <div id={'data-value-' + row.row.index}>{row.row.original.value}</div>
      ),
    },
  },
  {
    header: 'type',
    accessorKey: 'type',
    cellReturn: {
      name: 'row',
      key: '',
      value: (row: any) => (
        <div id={'data-type-' + row.row.index}>{row.row.original.type}</div>
      ),
    },
  },
  {
    header: 'isMicro',
    accessorKey: 'isMicro',
    cellReturn: {
      name: 'row',
      key: '',
      value: (row: any) => (
        <div id={'data-isMicro-' + row.row.index}>
          {row.row.original.isMicro}
        </div>
      ),
    },
  },
].map(createColumn);

// HYDRO
export const dataStatColumnsHydro: ColumnConfig[] = [
  {
    header: 'Synthèse',
    accessorKey: 'label',
    cellReturn: { name: 'data', key: '_hydro-label', value: 'label' },
  },
  {
    header: 'Effectif',
    accessorKey: 'effectif',
    size: 30,
    cellReturn: { name: 'data', key: '_hydro-effectif', value: 'effectif' },
  },
].map(createColumn);

// template for hydro detail popup
export const PopupComponent = (props) => {
  const handlerClick = () => {
    const div = document.getElementsByTagName(props.tagName)[0];
    if (div && div.parentNode) {
      div.parentNode.removeChild(div);
      props.setOpenModal && props.setOpenModal(false);
    }
    // we cannont pass history until this component to trigger reloading page by using router-dom
    // same way to pass function or trigger function to parent component (ParamComponent lost object and function)
    const divReload = document.getElementById('reloadTableAndMap');
    if (divReload) {
      divReload.click();
    } 
  };
  return (
    <div
      className='sds-reset-style'
      style={{
        position: 'fixed',
        background: '#00000050',
        width: '100%',
        height: '100vh',
        top: 0,
        left: 0,
        zIndex: 1,
      }}
    >
      <div
        className='box'
        style={
          props.module !== 'milieu'
            ? props.style
            : {
                position: 'relative',
                height: 'auto',
                background: '#fff',
                borderRadius: '14px',
                padding: '10px',
                border: '1px solid #999',
                margin: `calc(-20px + 5vh) auto 0px`,
                overflow: 'hidden',
                width: '1000px',
                maxHeight: 'none',
              }
        }
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            marginBottom: '15px',
          }}
        >
          <div style={{ flex: 1 }}>
            {props.title && (
              <h5 className="sds-word" style={{ margin: 0, paddingLeft: '0px', fontWeight: 'bold' }}>
                {props.title}
              </h5>
            )}
          </div>
          <div
            style={{ height: '25px', width: '25px', cursor: 'pointer', flexShrink: 0 }}
            onClick={handlerClick}
            onKeyDown={handlerClick}
          >
            <CloseIcon />
          </div>
        </div>
        {props.content}
      </div>
    </div>
  );
};

// dataStatColumnsHydroDetail
export const dataStatColumnsHydroDetail: ColumnConfig[] = [
  {
    header: 'Nature',
    accessorKey: 'nature',
    cellReturn: {
      name: 'row',
      key: 'Color',
      value: (row: any) => {
        // eslint-disable-next-line no-lone-blocks
        {
          return (
            <div id={'data-nature-' + row.row.id}>
              {row.row.original.nature}
            </div>
          );
        }
      },
    },
  },
  {
    header: 'Effectif',
    accessorKey: 'effectif',
    cellReturn: {
      name: 'row',
      key: 'Color',
      value: (row: any) => {
        // eslint-disable-next-line no-lone-blocks
        {
          return (
            <div id={'data-effectif-' + row.row.id}>
              {row.row.original.effectif}
            </div>
          );
        }
      },
    },
  },
].map(createColumn);

// DO
export const doColumns: ColumnConfig[] = [
  {
    header: '',
    accessorKey: 'Color',
    id: 'do-color',
    size: 20,
    cellReturn: { name: 'categ', key: '_do-color', value: 'Color' },
  },
  {
    header: 'Commune',
    accessorKey: 'Commune',
    id: 'do-commune',
    cellReturn: { name: 'data', key: '_do-commune', value: 'Commune' },
  },
  {
    header: 'Nom',
    accessorKey: 'Description',
    id: 'do-nom',
    cellReturn: { name: 'data', key: '_do-nom', value: 'Description' },
  },
  {
    header: 'Type',
    accessorKey: 'ModelCode',
    size: 80,
    id: 'do-type',
    cellReturn: { name: 'data', key: '_do-type', value: 'ModelCode' },
  },
].map(createColumn);

// INDUS
export const effectifValue = (acessorName: any) => {
  if (typeof acessorName === 'number') {
    switch (acessorName) {
      case 1:
        return '1 ou 2';
      case 2:
        return '3 à 5';
      case 3:
        return '6 à 9';
      case 11:
        return '10 à 19';
      case 12:
        return '20 à 49';
      case 21:
        return '50 à 99';
      case 22:
        return '100 à 199';
      case 31:
        return '200 à 249';
      case 32:
        return '250 à 499';
      case 41:
        return '500 à 999';
      case 42:
        return '1 000 à 1 999';
      case 51:
        return '2 000 à 4 999';
      case 52:
        return '5 000 à 9 999';
      default:
        return '10 000 et plus';
    }
  } else {
    switch (acessorName) {
      case '1':
        return '1 ou 2';
      case '2':
        return '3 à 5';
      case '3':
        return '6 à 9';
      case '11':
        return '10 à 19';
      case '12':
        return '20 à 49';
      case '21':
        return '50 à 99';
      case '22':
        return '100 à 199';
      case '31':
        return '200 à 249';
      case '32':
        return '250 à 499';
      case '41':
        return '500 à 999';
      case '42':
        return '1 000 à 1 999';
      case '51':
        return '2 000 à 4 999';
      case '52':
        return '5 000 à 9 999';
      default:
        return '10 000 et plus';
    }
  }
};
export const indusColumns: ColumnConfig[] = [
  {
    header: '',
    accessorKey: 'Color',
    id: 'indus-color',
    size: 35,
    cellReturn: { name: 'categ', key: '_indus-color', value: 'Color' },
  },
  {
    header: 'Etablissement',
    accessorKey: 'Name',
    id: 'indus-nom',
    cellReturn: { name: 'data', key: '_indus-name', value: 'Name' },
  },
  {
    header: 'Activité Principale',
    accessorKey: 'ActivityLabel',
    id: 'indus-section',
    cellReturn: { name: 'data', key: '_indus-section', value: 'ActivityLabel' },
  },
  {
    header: 'Note Glob.',
    accessorKey: 'Global_Note',
    id: 'indus-global-note',
    size: 20,
    cellReturn: {
      name: 'data',
      key: '_indus-global-note',
      value: 'Global_Note',
    },
  },
  {
    header: 'Nb Sal.',
    accessorKey: 'SalariedWorkforceSlice',
    id: 'indus-nb-sal',
    size: 40,
    cellReturn: {
      name: 'row',
      key: '_indus-nb-sal',
      value: (row: any) => {
        return (
          <div id={row.cell.id}>
            {effectifValue(row.row.original.SalariedWorkforceSlice)}
          </div>
        );
      },
    },
  },
].map(createColumn);

// PR
export const prColumns: ColumnConfig[] = [
  {
    header: '',
    accessorKey: 'Color',
    id: 'pr-color',
    size: 0,
    cellReturn: { name: 'categ', key: '_pr-color', value: 'Color' },
  },
  {
    header: 'Commune',
    accessorKey: 'Commune',
    cellReturn: { name: 'data', key: '_pr-commune', value: 'Commune' },
  },
  {
    header: 'Nom',
    size: 200,
    accessorKey: 'Description',
    cellReturn: { name: 'data', key: '_pr-nom', value: 'Description' },
  },
  {
    header: 'Type',
    accessorKey: 'ModelCode',
    size: 80,
    cellReturn: { name: 'data', key: '_pr-type', value: 'ModelCode' },
  },
].map(createColumn);

// function to color sensibility note thanks to categ
export const defineColor = (row: any, field: string) => {
  switch (row[field]) {
    case 'ROUGE':
      return 'red';
    case 'ORANGE':
      return 'orange';
    case 'BLEU':
      return 'blue';
    case 'VERT':
      return 'green';
    case 'GRIS':
      return 'grey';
    default:
      return 'black';
  }
};

// milieu
export const milieuColumns: ColumnConfig[] = [
  {
    header: 'Sensibilité',
    accessorKey: 'SensibilityNote',
    id: 'sensibility-note',
    size: 80,
    cellReturn: {
      name: 'row',
      key: '',
      value: (row: any) => (
        <div
          id={row.cell.id}
          style={{
            color: defineColor(row.row.original, 'SensibilityColor'),
          }}
        >
          {row.row.original.SensibilityNote !== null
            ? row.row.original.SensibilityNote
            : 'NR'}
        </div>
      ),
    },
  },
  {
    header: 'Dilution',
    accessorKey: 'DilutionNote',
    id: 'dilution-note',
    size: 80,
    cellReturn: {
      name: 'row',
      key: '',
      value: (row: any) => (
        <div
          id={row.cell.id}
          style={{
            color: defineColor(row.row.original, 'DilutionColor'),
          }}
        >
          {row.row.original.DilutionNote !== null
            ? row.row.original.DilutionNote
            : 'NR'}
        </div>
      ),
    },
  },
  {
    header: 'Type',
    accessorKey: 'ModelCode',
    size: 80,
    id: 'milieu-type',
    cellReturn: { name: 'data', key: '_milieu-type', value: 'ModelCode' },
  },
  {
    header: 'Installation',
    accessorKey: 'Description',
    id: 'milieu-nom',
    cellReturn: { name: 'data', key: '_milieu-nom', value: 'Description' },
  },
].map(createColumn);

// PLUIE
export const pluieColumns: ColumnConfig[] = [
  {
    header: '',
    accessorKey: 'Color',
    id: 'pluie-color',
    size: 50,
    cellReturn: { name: 'categ', key: '_pluie-color', value: 'Color' },
  },
  {
    header: 'Commune',
    accessorKey: 'Commune',
    id: 'pluie-commune',
    cellReturn: { name: 'data', key: '_pluie-commune', value: 'Commune' },
  },
  {
    header: 'Nom',
    accessorKey: 'Description',
    id: 'pluie-nom',
    cellReturn: { name: 'data', key: '_pluie-nom', value: 'Description' },
  },
  {
    header: 'Type',
    accessorKey: 'ModelCode',
    size: 80,
    id: 'pluie-type',
    cellReturn: { name: 'data', key: '_pluie-type', value: 'ModelCode' },
  },
  {
    header: 'Vol/m³',
    accessorKey: 'ModelCode',
    id: 'pluie-volume',
    size: 0,
    cellReturn: {
      name: 'row',
      key: '_pluie-event-vol',
      value: (row: any) => {
        return (
          <div id={row.cell.id}>
            {(row.row.original.Volume !== null && row.row.original.Volume !== undefined)
              ? new Intl.NumberFormat('fr-FR', {}).format(
                  row.row.original.Volume.toFixed(),
                )
              : 'NR'}
          </div>
        );
      },
    },
  },
  {
    header: 'Pluie/mm',
    accessorKey: 'Mesure',
    id: 'pluie-mesure',
    size: 0,
    cellReturn: { name: 'data', key: '_pluie-mesure', value: 'Mesure' },
  },
].map(createColumn);

// ADMINISTRATION USERS
export const adminUsersColumns: ColumnConfig[] = [
  {
    header: 'Nom',
    accessorKey: 'email',
    id: 'admin-users-name',
    cellReturn: { name: 'data', key: '_admin-users-name', value: 'email' },
  },
  {
    header: 'Rôle',
    accessorKey: 'role',
    id: 'admin-users-role',
    cellReturn: { name: 'data', key: '_admin-users-role', value: 'role' },
  },
  // {
  //   header: 'Espace Client',
  //   accessorKey: 'EspaceClient',
  //   id: 'admin-users-espace-client',
  //   cellReturn: { name: 'data', key: '_admin-users-espace-client', value: 'EspaceClient' },
  // },
  // {
  //   header: 'Date de début',
  //   accessorKey: 'DateDebut',
  //   size: 80,
  //   id: 'admin-users-date-debut',
  //   cellReturn: { name: 'data', key: '_admin-users-date-debut', value: 'DateDebut' },
  // },
  // {
  //   header: 'Date de fin',
  //   accessorKey: 'DateFin',
  //   id: 'admin-users-date-fin',
  //   cellReturn: { name: 'data', key: '_admin-users-date-fin', value: 'DateFin' },
  // },
  {
    header: 'Statut',
    accessorKey: 'enabled',
    id: 'admin-users-statut',
    cellReturn: {
      name: 'row',
      key: '_admin-users-statut',
      value: (row: any) => {
        return (
          <div id={row.cell.id}>
            {row.row.original.enabled ? (
              pointColor({
                className: 'vert',
                id: row.cell.id,
                color: '#76D19B',
              })
            ) : (
              pointColor({
                className: 'red',
                id: row.cell.id,
                color: '#FE3123',
              })
            )}
          </div>
        );
      },
    },
  },
  
].map(createColumn);

export const dataEventsColumnsPluieDetail: ColumnConfig[] = [
  {
    header: 'Date début',
    accessorKey: 'startDate',
    id: 'pluie-startDate',
    size: 0,
    cellReturn: { name: 'data', key: '_pluie-event-start', value: 'startDate' },
  },
  {
    header: 'Date fin',
    accessorKey: 'endDate',
    id: 'pluie-endDate',
    size: 0,
    cellReturn: { name: 'data', key: '_pluie-event-end', value: 'endDate' },
  },
  {
    header: 'Vol déversé(m³)',
    accessorKey: 'dumpedVolume',
    id: 'pluie-event-vol',
    size: 0,
    cellReturn: {
      name: 'row',
      key: '_pluie-event-vol',
      value: (row: any) => {
        return (
          <div id={row.cell.id}>
            {row.row.original.dumpedVolume !== null
              ? new Intl.NumberFormat('fr-FR', {}).format(
                  row.row.original.dumpedVolume.toFixed(1),
                )
              : 'NR'}
          </div>
        );
      },
    },
  },
  {
    header: "Lame d'eau",
    accessorKey: 'curveNumber',
    id: 'pluie-event-water',
    size: 0,
    cellReturn: {
      name: 'data',
      key: '_pluie-event-water',
      value: 'curveNumber',
    },
  },
  {
    header: 'Seuil de déversement',
    accessorKey: 'dumpedTreshold',
    id: 'pluie-event-streshold',
    size: 0,
    cellReturn: {
      name: 'data',
      key: '_pluie-event-streshold',
      value: 'dumpedTreshold',
    },
  },
].map(createColumn);

export const collectionPoolColumns: ColumnConfig[] = [
  {
    header: 'Bassin de collecte',
    accessorKey: 'collectionPoolName',
    id: 'collectionPool-name',
    size: 150,
    cellReturn: {
      name: 'data',
      key: '_collectionPool-name',
      value: 'collectionPoolName',
    },
  },
  {
    header: 'Point limite aval',
    accessorKey: 'collectionPoolAvalPoint',
    id: 'aval_point_limite',
    size: 150,
    cellReturn: {
      name: 'data',
      key: '_aval_point_limite',
      value: 'collectionPoolAvalPoint',
    },
  },
  {
    header: 'PR MR',
    accessorKey: '_PRMR',
    id: 'pr_mr',
    size: 10,
    enableSorting: false,
    cellReturn: {
      name: 'categ',
      key: '_pr_mr',
      value: 'prmrColor',
    },
  },
  {
    header: 'DO TP',
    accessorKey: '_DOTP',
    id: 'do_tp',
    size: 10,
    enableSorting: false,
    cellReturn: {
      name: 'categ',
      key: '_do_tp',
      value: 'dotpColor',
    },
  },
  {
    header: 'ECP',
    accessorKey: '_ECP',
    id: 'ecp',
    size: 10,
    enableSorting: false,
    cellReturn: {
      name: 'categ',
      key: '_ecp',
      value: 'ecpColor',
    },
  },
  {
    header: 'H2S',
    accessorKey: '_H2S',
    id: 'h2s',
    size: 10,
    enableSorting: false,
    cellReturn: {
      name: 'categ',
      key: '_h2s',
      value:'h2SColor',
    },
  },
  {
    header: 'PLUIE',
    accessorKey: '_pluie',
    id: 'pluie',
    size: 10,
    enableSorting: false,
    cellReturn: {
      name: 'categ',
      key: '_pluie',
      value: 'pluieColor',
    },
  },
  {
    header: 'MILIEU',
    accessorKey: '_milieu',
    id: 'milieu',
    size: 10,
    enableSorting: false,
    cellReturn: { name: 'categ', key: '_pluie', value: 'milieuColor' },
  },
  {
    header: 'HYDRO',
    accessorKey: '_Hydro',
    id: 'hydro',
    size: 10,
    enableSorting: false,
    cellReturn: {
      name: 'categ',
      key: '_hydro',
      value: 'hydroColor',
    },
  },
  {
    header: 'INDUS',
    accessorKey: '_Indus',
    id: 'indus',
    size: 10,
    enableSorting: false,
    cellReturn: {
      name: 'categ',
      key: '_indus',
      value: 'indusColor',
    },
  },
].map(createColumn);

export const ecpDetailColumns: ColumnConfig[] = [
  {
    header: 'Date',
    accessorKey: 'date',
    id: 'ecp-detail-date',
    size: 50,
    enableSorting: false,
    cellReturn: { name: 'data', key: 'ecp-detail-date', value: 'date' },
  },
  {
    header: 'Boon & lister',
    accessorKey: 'boonAndLister',
    id: 'ecp-detail-boonAndLister',
    size: 50,
    enableSorting: false,
    cellReturn: {
      name: 'row',
      key: 'ecp-detail-boonAndLister',
      value: (row: any) => {
        return (
          <div id={row.cell.id}>
            {row.row.original.boonAndLister !== null
              ? Number(row.row.original.boonAndLister).toLocaleString() +
                ' mg/L'
              : 'NR'}
          </div>
        );
      },
    },
  },
  {
    header: 'Temps séjour canalisation',
    accessorKey: 'canaSojourn',
    id: 'ecp-detail-canaSojourn',
    size: 50,
    enableSorting: false,
    cellReturn: {
      name: 'data',
      key: 'ecp-detail-canaSojourn',
      value: 'canaSojourn',
    },
  },
  {
    header: 'Temps séjour PR',
    accessorKey: 'prSojourn',
    id: 'ecp-detail-prSojourn',
    size: 50,
    enableSorting: false,
    cellReturn: {
      name: 'row',
      key: 'ecp-detail-prSojourn',
      value: (row: any) => {
        return (
          <div id={row.cell.id}>
            {row.row.original.prSojourn !== null
              ? Number(row.row.original.prSojourn).toLocaleString() +
                ' dem/Jour'
              : 'NR'}
          </div>
        );
      },
    },
  },
  {
    header: 'Vitesse autocurage',
    accessorKey: 'selfCleaning',
    id: 'ecp-detail-selfCleaning',
    size: 50,
    enableSorting: false,
    cellReturn: {
      name: 'row',
      key: 'ecp-detail-selfCleaning',
      value: (row: any) => {
        return (
          <div id={row.cell.id}>
            {row.row.original.selfCleaning !== null
              ? row.row.original.selfCleaning + ' m/s'
              : 'NR'}
          </div>
        );
      },
    },
  },
].map(createColumn);
